import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Icon } from '@/shared/ui';

import { templateEditorMessages } from '../../config';
import { EditorButton } from '../EditorButton';

import styles from './AiInstructionsButton.module.scss';

type AiInstructionsButtonProps = {
  hasInstructions: boolean;
  readOnly?: boolean;
  className?: string;
  onClick: () => void;
};

export const AiInstructionsButton: FC<AiInstructionsButtonProps> = (props) => {
  const { hasInstructions, readOnly, className, onClick } = props;

  const { formatMessage } = useIntl();

  return (
    <EditorButton
      variant="icon"
      disabled={readOnly}
      className={cn(styles.button, hasInstructions && styles.filled, className)}
      title={formatMessage(templateEditorMessages.aiInstructionsTitle)}
      onClick={onClick}
    >
      <Icon
        name={hasInstructions ? 'commentAiFilled' : 'commentAi'}
        size={24}
      />
    </EditorButton>
  );
};
